<!-- generate template for a single hike -->
<template>
  <div class="container">
    <hr class="space space-xs">
    <router-link to="/hikes" class="btn btn-primary mb-3"> <i class="fa fa-chevron-left"></i> Вернуться к списку походов</router-link>
    <loader v-if="isLoading"></loader>
    <div class="row mb-4" v-else>
      <div class="col-12 mb-4">
        <div class="d-flex">
          <h1 class="h2">{{ hike.title }}</h1>
          <router-link class="btn btn-light ml-3" :to="{ name: 'hike-add', params: { id: hike.id } }" v-if="hike.submittedBy == user.id">Редактировать поход</router-link>
        </div>
        <p v-if="hike.description">{{ hike.description }}</p>
      </div>
      <div class="col-6 col-lg-2 mb-3">
        <p class="text-muted small text-uppercase">Дистанция</p>
        <div class="d-flex align-items-end">
          <img width="36" style="height:36px;" src="https://zabugorshiki.com/wp-content/themes/understrap-child/images/icons/route.png" alt="">
          <h4 class="my-0 ml-2">{{ hike.distance }} км</h4>
        </div>
      </div>
      <div class="col-6 col-lg-2">
        <p class="text-muted small text-uppercase">Сложность</p>
        <div class="d-flex align-items-end">
          <img width="36" style="height:36px;" src="https://zabugorshiki.com/wp-content/themes/understrap-child/images/icons/hiking.png" alt="">
          <h4 class="my-0 ml-2">{{ hike.difficulty }}/5</h4>
        </div>
      </div>
      <div class="col-6 col-lg-2">
        <p class="text-muted small text-uppercase">Набор высоты</p>
        <div class="d-flex align-items-end">
          <img width="36" style="height:36px;" src="https://zabugorshiki.com/wp-content/themes/understrap-child/images/icons/outdoor.png" alt="">
          <h4 class="my-0 ml-2">{{ hike.elevation }} м</h4>
        </div>
      </div>
      <div class="col-6 col-lg-2">
				<p class="text-muted small text-uppercase">Длительность</p>
				<div class="d-flex align-items-end">
					<img width="36" style="height:36px;" src="https://zabugorshiki.com/wp-content/themes/understrap-child/images/icons/day.png" alt="">
					<h4 class="my-0 ml-2">{{ hike.durationHours }} часов</h4>
				</div>
			</div>
      <div class="col-6 col-lg-3" v-if="!isLoading && weather && weather.temp">
        <p class="text-muted small text-uppercase">Текущая погода в месте старта</p>
        <div class="d-flex align-items-center">
          <img :src="'https://openweathermap.org/img/wn/' + weather.icon + '.png'" alt="" width="36" style="height:36px;">
          <div>
            <h4 class="my-0 ml-2">{{ weather.temp }}°C</h4>
            <!-- <p class="ml-2">{{ weather.description }}</p> -->
          </div>
        </div>
      </div>
      <div class="col-12">
        <!-- <p>Дата похода: {{ hike.startDate }}</p> -->
        <!-- <p>Создан: {{ hike.createdAt }}</p> -->
        <!-- <p>Обновлен: {{ hike.updatedAt }}</p> -->
      </div>
    </div>
    <loader v-show="mapIsLoading"></loader>
    <div class="row">
      <div class="col-md-8">
        <div id="map" style="height: 600px; width: 100%;"></div>
      </div>
      <div class="col-md-4" v-if="!isLoading">
        <div class="card bg-light mb-3">
          <div class="card-body">
            <h5>Как открыть GPS-трек:</h5>
            <ul class="pl-3">
              <li><strong>На телефоне:</strong> приложения для GPS-навигации, такие как Google Maps, Mapy</li>
              <li><strong>На компьютере:</strong> Google Earth</li>
            </ul>
            <p class="mb-0">Чтобы открыть файл GPS-трека, скачайте его и откройте в приложении или импортируйте в приложение. После открытия файла вы сможете просмотреть трек на карте.</p>
          </div>
        </div>

        <a class="btn btn-primary btn-block" :href="hike.gpsTrackURL"><i class="fa fa-download"></i> Скачать GPS трек</a>
        <button class="btn btn-success btn-block" @click="inviteFriend"><i class="fa fa-share"></i> Пригласить друга в поход</button>
      </div>
    </div>
    
    <div v-if="hike && hike.youtubeURL" class="embed-responsive embed-responsive-16by9 my-5">
      <iframe width="100%" height="315" :src="'https://www.youtube.com/embed/' + getVideoId(hike.youtubeURL)" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import L from 'leaflet'
import 'leaflet-gpx'
import 'leaflet/dist/leaflet.css'
import xml2js from 'xml2js'

export default {
  name: 'Hike',
  data () {
    return {
      isLoading: true,
      mapIsLoading: false,
      map: null,
      gpx: null,
      weather: {},
      coordinates: {
        lat: null,
        lon: null
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      hike: state => state.hikes.hike
    })
  },
  created () {
    window.scrollTo(0, 0)
    this.getHike()
    this.getCurrentWeather()
  },
  async mounted () {
    if (this.hike && this.hike.gpsTrackURL) {
      await this.$nextTick()
      this.loadGpxTrack(this.hike.gpsTrackURL)
    }
  },
  methods: {
    inviteFriend () {
      const url = window.location.href
      const text = 'Присоединяйся ко мне в походе!'
      const message = `${text} ${url}`

      navigator.clipboard.writeText(url).then(() => {
        // Сообщение, которое будет показано после успешной копирования
        this.$bvToast.toast(message, {
          title: 'Ссылка скопирована',
          autoHideDelay: 5000,
          appendToast: true,
          variant: 'success'
        })
      }).catch(() => {
        // Сообщение, которое будет показано, если не удалось скопировать ссылку
        this.$bvToast.toast('Не удалось скопировать ссылку', {
          title: 'Ошибка',
          autoHideDelay: 5000,
          appendToast: true,
          variant: 'danger'
        })
      })
    },
    getHike () {
      this.isLoading = true
      this.$store.dispatch('GET_HIKE', this.$route.params.id)
        .then(() => {
          this.isLoading = false
        })
    },
    async loadGpxTrack (gpsTrackURL) {
      // Create the map if it doesn't exist yet
      if (!this.map) {
        this.map = L.map('map').setView([0, 0], 2)
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution:
            '&copy; <a href="https://zabugorshiki.com">Zabugorshiki</a>'
        }).addTo(this.map)
      }

      // Remove the previous GPX layer if it exists
      if (this.gpx) {
        this.map.removeLayer(this.gpx)
      }

      // Load and display the GPX file on the map
      this.gpx = new L.GPX(gpsTrackURL, {
        async: true,
        marker_options: {
          startIconUrl: '/static/images/icons/pin-icon-start.png',
          endIconUrl: '/static/images/icons/pin-icon-end.png',
          shadowUrl: '/static/images/icons/pin-shadow.png'
        }
      })

      this.gpx.on('loaded', (e) => {
        this.map.fitBounds(e.target.getBounds())
        this.mapIsLoading = false
        this.getGpxCoordinates(e.target)
        // this.getGPSTrackDetails(e.target)
      })

      this.map.addLayer(this.gpx)

      // Fetch and parse the GPX file
      const response = await fetch(gpsTrackURL)
      const gpxText = await response.text()
      const parser = new xml2js.Parser()
      const gpxData = await parser.parseStringPromise(gpxText)

      // Get the coordinates from the parsed GPX data
      this.getGpxCoordinates(gpxData)
    },
    getGPSTrackDetails (gpxData) {
      const getOrEmpty = (fn) => {
        try {
          const result = fn()
          return result !== undefined ? result : ''
        } catch (e) {
          return ''
        }
      }

      const name = getOrEmpty(() => gpxData.get_name())
      const startTime = getOrEmpty(() => gpxData.get_start_time().toDateString() + ', ' + gpxData.get_start_time().toLocaleTimeString())
      const distance = getOrEmpty(() => gpxData.get_distance().toFixed(2))
      const duration = getOrEmpty(() => gpxData.get_duration_string(gpxData.get_moving_time()))
      const pace = getOrEmpty(() => gpxData.get_duration_string(gpxData.get_moving_pace(), true))
      const avgHr = getOrEmpty(() => gpxData.get_average_hr())
      const elevationGain = getOrEmpty(() => gpxData.get_elevation_gain()).toFixed(0)
      const elevationLoss = getOrEmpty(() => gpxData.get_elevation_loss()).toFixed(0)
      const elevationNet = getOrEmpty(() => gpxData.get_elevation_gain() - gpxData.get_elevation_loss()).toFixed(0)
      const maxElevation = getOrEmpty(() => gpxData.get_elevation_max()).toFixed(0)
      const minElevation = getOrEmpty(() => gpxData.get_elevation_min()).toFixed(0)

      this.gpsTrackDetails = {
        name,
        startTime,
        distance,
        duration,
        pace,
        avgHr,
        elevationGain,
        elevationLoss,
        elevationNet,
        maxElevation,
        minElevation
      }
    },
    getGpxCoordinates (gpxData) {
      if (
        gpxData &&
        gpxData.gpx &&
        gpxData.gpx.trk &&
        gpxData.gpx.trk[0] &&
        gpxData.gpx.trk[0].trkseg &&
        gpxData.gpx.trk[0].trkseg[0] &&
        gpxData.gpx.trk[0].trkseg[0].trkpt &&
        gpxData.gpx.trk[0].trkseg[0].trkpt[0]
      ) {
        this.coordinates.lat = parseFloat(gpxData.gpx.trk[0].trkseg[0].trkpt[0].$.lat)
        this.coordinates.lon = parseFloat(gpxData.gpx.trk[0].trkseg[0].trkpt[0].$.lon)
        this.getCurrentWeather()
      }
    },
    async getCurrentWeather () {
      if (!this.coordinates.lat || !this.coordinates.lon) return

      const apiKey = 'fbabf09292b982e8bd5eb3616dc9aa60' // Replace with your actual API key
      const { lat, lon } = this.coordinates

      try {
        const response = await fetch(`https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lon}&appid=${apiKey}&units=metric`)
        const data = await response.json()

        this.weather = {
          temp: data.main.temp.toFixed(0),
          description: data.weather[0].description,
          icon: data.weather[0].icon
        }
      } catch (error) {
        console.error('Error fetching weather data:', error)
      }
    },
    getVideoId (url) {
      let videoId

      // Check if the URL is a regular YouTube URL with the "v=" parameter
      if (url.includes('v=')) {
        const startIndex = url.indexOf('v=') + 2
        const endIndex = url.indexOf('&', startIndex)
        videoId = endIndex !== -1 ? url.substring(startIndex, endIndex) : url.substring(startIndex)
      } else {
        // Check if the URL is a shortened YouTube URL
        const startIndex = url.indexOf('youtu.be/') + 9
        const endIndex = url.indexOf('?', startIndex)
        videoId = endIndex !== -1 ? url.substring(startIndex, endIndex) : url.substring(startIndex)
      }

      return videoId
    }
  },
  watch: {
    'hike.gpsTrackURL' (newGpsTrackURL, oldGpsTrackURL) {
      if (newGpsTrackURL !== oldGpsTrackURL) {
        if (this.hike.gpsTrackURL) {
          this.mapIsLoading = true
          this.loadGpxTrack(newGpsTrackURL)
        }
      }
    }
  }
}
</script>